export default "__VITE_ASSET__B5WC1CGl__"